<template>
  <div class="wrapper container">

    <div class="menu-wrapper" v-if="!isMobile">
      <div class="menu">
        <h1 class="menu-title">常见问题</h1>
        <p :class="{'active': activeIndex === index}" class="question" v-for="(item, index) in menuList" :key="item + '' + index" @click="scrollToTarget(index)">{{index + 1 + '.' + item}}</p>
      </div>
    </div>

    <div v-else class="menu-m">{{ menuList[activeIndex] }}</div>

    <div class="content">

      <h2 class="title">官网常见问题</h2>

      <div id="item-1" class="item one index">
        <h4 class="sub-title">TGO 鲲鹏会是什么？</h4>
        <p>简而言之，TGO 鲲鹏会类似是一个 CTO 俱乐部。</p>
        <p>TGO 是汇聚全球科技领导者的高端学习社区。在这里，所有孤军奋战的技术管理者都能找到自己的同侪（chai，二声）。TGO 目前在北京、上海、广州、深圳、杭州、南京、成都、厦门、台北、硅谷、武汉、苏州等十二个城市设立。总体累计学员超过 1700 人， 60% 以上皆为 CTO、COO、技术 VP、有技术背景的 CEO 等科技领导者，他们遍布如企业服务、O2O 生活服务、互联网金融、电商等各大行业。</p>
      </div>

      <div id="item-2" class="item two index">
        <h4 class="sub-title">TGO 鲲鹏会的加入标准是什么？</h4>
        <img src="../../assets/img/t1.png" preview="0" width="100%" alt="">
      </div>

      <div id="item-3" class="item three">
        <h4 class="sub-title">TGO 鲲鹏会的加入流程是什么？</h4>
        <img src="./assets/image/t2.png" preview="0" width="100%" alt="">
      </div>

      <div id="item-4" class="item four index">
        <h4 class="sub-title">TGO 鲲鹏会的学费金额是多少？</h4>
        <p class="unit">从 2023 年 4 月 1 日起，TGO 鲲鹏会新学员会费调整为 10080/年/人。同时，取消“企业学员”和“标准学员”的分类，统一为 TGO 鲲鹏会学员。</p>
        <p class="unit">TGO 鲲鹏会实行财年制度，财年周期是当年的7月1日至次年的6月30日，每年的7月1日统一结算学费，不满一年会按照月份来折算学费。</p>
        <p class="unit">例如：A 于 2022 年 4 月 12 日填写申请表，申请加入 TGO 鲲鹏会；于 4 月 13 日通过资料初审、4 月 15 日通过面试，则起会籍期限及应收金额为：</p>
        <p class="unit dot wrap"><span class="strong">会籍期限：</span>2022 年 5 月 1 日-2023 年 6 月 30 日（共计 14 个月）</p>
        <p class="unit dot wrap"><span class="strong">学费金额：</span>10080 / 12 * 14 = 11760元</p>
      </div>

      <div id="item-5" class="item five index">
        <h4 class="sub-title">学费可以打折吗？</h4>
        <p>TGO 鲲鹏会学费都是统一价格，没有折扣。TGO 鲲鹏会学员学费的 60% 是用来支持当地的运营，40% 用于年度学员服务。 </p>
      </div>

      <div id="item-6" class="item six index">
        <h4 class="sub-title">TGO 鲲鹏会的活动有哪些？</h4>
        <p class="unit">TGO 鲲鹏会活动主要是线下的，主要分为两种：一种是私密小组活动、一种是公开学习活动</p>
        <p class="unit dot wrap"><span class="strong">小组活动：</span>您加入之后会按照您的行业背景、专业领域等给您划到一个 8-10 人的小组内，小组成员每月将不定时进行线下的见面沟通，交流经验、互学互助。</p>
        <p class="unit dot wrap"><span class="strong">活动：</span>TGO 鲲鹏会的每个地区在每个月中，都将有 1-2 场公开学习活动，主题不同、形式各样，包含大咖演讲分享、议桌局、闭门讨论、亲子活动、户外探索、企业参访等。每年每个董事会成员都会根据学员需求和前沿技术趋势以制定本年度的全年学习规划，从而为学员创造丰富的学习机会，构建高质的交流平台。</p>
        <p>由于 TGO 鲲鹏会主打的小圈子深度交流，公开学习活动的参会规模为 30-80 人不等，95% 为 TGO 鲲鹏会学员，5% 的名额可开放给 TGO 鲲鹏会学员引荐的朋友或同事（需工作人员审核通过）。</p>
      </div>

      <div id="item-7" class="item seven index">
        <h4 class="sub-title">公开学习活动和小组活动的区别是什么？</h4>
        <p class="unit">首先小组活动的人员是固定的，讨论的内容、举办的时间、分享人都是小组内部来决定的，落地实施也是由小组成员来完成；</p>
        <p class="unit">公开学习活动是由 TGO 鲲鹏会发起，活动时间和主题是由 TGO 鲲鹏会当地区域经理和董事会讨论共同决定，当地区域经理负责活动策划、讲师邀请、活动执行、活动宣传等。您加入 TGO  鲲鹏会后，每月可根据自己的需求和话题匹配程度确定出席哪些活动，同时也欢迎邀请您的朋友参与。</p>
      </div>

      <div id="item-8" class="item eight index">
        <h4 class="sub-title">面试的标准是什么，面试官是谁？</h4>
        <p class="unit">面试一般的形式是：线下一对一沟通（如遇特殊情况，可能改为电话沟通），面聊时间为 1h 左右，面试地点可与面试官商讨确定。面试内容主要分为两个部分：第一部分是您的个人经历介绍，以及能给现有的 TGO 鲲鹏会学员带来的价值；第二部分是您加入 TGO 鲲鹏会的主要诉求。每次参与面试的面试官为当地的董事会成员，面试官会在面试过程中向您传递 TGO 鲲鹏会能带来的价值与您的诉求是否匹配。</p>
        <p class="unit">董事会成员名单，<a href="https://tgo.infoq.cn/we/branches" class="primary">点此查看</a></p>
      </div>

      <div id="item-9" class="item nine index">
        <h4 class="sub-title">TGO 鲲鹏会每个地区都有董事会，董事会具体是干什么的？</h4>
        <p class="unit">TGO 鲲鹏会是一个学员共建的组织，通过“共建、自治”的方式维护当地的健康发展，为学员提供必要的服务，帮助学员个人更好地学习和成长，帮助学员企业之间更好地合作和交流，进而促进创新技术和商业更好地融合，推动社会的进步。</p>
        <p class="unit">因此，每个地区都会由当地董事会成员与 TGO 鲲鹏会管理团队根据 TGO 鲲鹏会的愿景和价值观共同运营。TGO 鲲鹏会董事会委员由当地学员担任，是当地的高级管理人员，对当地运营有全部知情权与共同决定权。同时，各董事会也会由 TGO 鲲鹏会总部直接管理，其发展方向需要与极客邦科技发展方向保持一致。</p>
        <h6 class="three-title">董事会委员职责基本划分如下：</h6>
        <p class="unit dot wrap"><span class="strong">负责人：</span>负责把控当地董事会的总体方向，带领董事会制定年度发展目标以及实施计划，以满足学员学习和运营的需要，提升 TGO 鲲鹏会在当地的影响力；</p>
        <p class="unit dot wrap"><span class="strong">学习产品负责人：</span>负责规划、协调学习活动，主要是确保学习质量，比如协调自己和董事会视野范围内最好的分享讲师，根据学员的反馈调整学习的频率和内容等；</p>
        <p class="unit dot wrap"><span class="strong">会籍负责人：</span>协调招募潜在学员，面试符合标准、高质量的学员，作为当地的形象代言人，传播 TGO 鲲鹏会的价值；</p>
        <p class="unit dot wrap"><span class="strong">服务负责人：</span>负责新学员成为正式学员期间的服务工作，通过欢迎、连接、指引三个步骤帮助新学员快速获取到 TGO 鲲鹏会的价值，包括已有学员的体验，和协调招待其他地区来访学员等。</p>
        <p class="unit dot wrap"><span class="strong">小组负责人：</span>负责新学员进入小组的安置事宜，负责组长之间最佳实践经验的分享，提升学员小组体验，比如定期组长组长会议等。</p>

      </div>

      <div id="item-10" class="item ten index">
        <h4 class="sub-title">加入 TGO 鲲鹏会之后，我可以享受哪些学员权益？</h4>

        <p class="unit">从 2023 年 4 月 1 日起，TGO 鲲鹏会新学员会费调整为 10080/年/人。同时，取消“企业学员”和“标准学员”的分类，统一为 TGO 鲲鹏会学员，权益也归为一种。</p>
        <p class="unit">主要包括参加 TGO 鲲鹏会活动、个人品牌打造；其中，TGO 鲲鹏会活动包括：小组活动、公开学习活动、全年 30 场大型全天培训活动、GTLC全球总站及分站、由各小组或 TGO 鲲鹏会官方发起的活动类别、企业宣传或资源对接相关的权益、技术团队招聘、品牌打造、产品推荐、优秀案例展示、企业团队成长、极客邦资源专属折扣等服务，持续影响潜在市场及潜在客户等。</p>
      </div>

      <div id="item-11" class="item eleven index">
        <h4 class="sub-title">可以开票吗？开票的内容和税点是多少？电子票还是纸质的发票？</h4>
        <p class="unit">可以</p>
        <p class="unit dot"><span class="strong">开票内容：</span>会员费、服务费、技术服务费、信息服务费、会议服务费、技术培训费</p>
        <p class="unit dot"><span class="strong">开票税点：</span>6%</p>
        <p class="unit dot wrap"><span class="strong">开票类型：</span>纸质专票、纸质普票</p>
      </div>

      <div id="item-12" class="item twelve index">
        <h4 class="sub-title">TGO 鲲鹏会和其他组织的区别是什么？有什么不一样？</h4>
        <img src="./assets/image/t3.jpg" preview="0" width="100%" alt="">

        <!-- <div class="table">
          <table>
            <thead>
              <tr>
                <th>项目</th><th>TGO 鲲鹏会</th><th>某训练营</th><th>某 MBA/某 EMBA</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>运营性质</td><td>学费非营利</td><td>营利</td><td>营利</td>
              </tr>
              <tr>
                <td>运营模式</td><td>同侪学习</td><td>专家授课</td><td>专家授课</td>
              </tr>
              <tr>
                <td>目标群体</td><td>CTO 为主的科技领导者</td><td>要成长为 CTO 的技术人</td><td>创始人、企业家</td>
              </tr>
              <tr>
                <td>现有学员属性</td><td>约 70% 为 CTO、技术 VP 等</td><td>约 50% 为总监等</td><td>创始人、企业家</td>
              </tr>
              <tr>
                <td>按年连续付费</td><td>是</td><td>否</td><td>否</td>
              </tr>
              <tr>
                <td>年度学费率</td><td>约 80%</td><td>—</td><td>—</td>
              </tr>
              <tr>
                <td>全球化</td><td>全球 12 个地区，均有全职工作人员</td><td>固定地区上课+地区游学</td><td>固定地区上课</td>
              </tr>
              <tr>
                <td>跨地区接待</td><td>有</td><td>无</td><td>无</td>
              </tr>
              <tr>
                <td>付费学员组成的董事会</td><td>有</td><td>无</td><td>无</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>

    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      fixed: false,
      activeIndex: 0,
      itemTopList: [],
      menuList: [
        'TGO 鲲鹏会是什么？',
        'TGO 鲲鹏会的加入标准及加入流程是什么？',
        'TGO 鲲鹏会的学费金额是多少？',
        '学费可以打折吗？',
        'TGO 鲲鹏会的活动有哪些？',
        '公开学习活动和小组活动的区别是什么？',
        '面试的标准是什么，面试官是谁？',
        'TGO 鲲鹏会每个地区都有董事会，董事会具体是干什么的？',
        '加入 TGO 鲲鹏会之后，我可以享受哪些学员权益？',
        '可以开票吗？开票的内容和税点是多少？电子票还是纸质的发票？',
        'TGO 鲲鹏会和其他组织的区别是什么？有什么不一样？'
      ]
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  methods: {
    scrollToTarget (i) {
      window.removeEventListener('scroll', this.listenScrollTop)
      this.activeIndex = i
      this.$scrollTo(`#item-${i + 1}`, 500, {
        offset: -76,
        onDone: () => {
          window.addEventListener('scroll', this.listenScrollTop)
        }
      })
    },
    listenScrollTop () {
      var nowY = window.pageYOffset
      var index = 0

      if (nowY > this.itemTopList[0]) {
        this.fixed = true
      } else {
        this.fixed = false
      }

      while (nowY > this.itemTopList[index]) {
        index++
      }
      if (index !== 0) index--
      this.activeIndex = index
    }
  },
  created () {
  },
  mounted () {
    var itemList = document.getElementsByClassName('index')
    itemList.forEach(ele => {
      this.itemTopList.push(ele.offsetTop)
    })

    window.addEventListener('scroll', this.listenScrollTop, false)
  }
}
</script>
<style scoped lang='scss'>
  @import '../../style/bulma/app.sass';
  @import '../../style/base/article.scss';

  .container {
    display: flex;
    @include mobile {
      padding-top: 3rem;
    }
  }

  .menu {
    position: sticky;
    top: 60px;
    width: 255px;
    // border-right: 1px solid rgba(235, 235, 235, 0.5);
    padding: 64px 0;
    &::after {
      content: '';
      width: 1px; height: calc(100% - 128px);
      background-color: rgba(235, 235, 235, 0.5);
      position: absolute; right: 0; top: 64px;
    }

    .menu-title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .question {
      width: 210px;
      color: #4A4A4A;
      font-size: 13px;
      margin-bottom: 15px;
      cursor: pointer;
    }

    .active {
      color: $primary3;
    }
  }

  .menu-m {
    position: fixed; top: 0; left: 0; z-index: 1;
    width: 100%;
    // height: 35px;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    line-height: 30px;
    background: #fff;
    border-left: 3px solid $primary3;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .content {
    margin-left: 65px;
    margin-right: 0;
    margin-bottom: 80px;
    @include mobile {
      margin: 0;
      .sub-title {
        line-height: 1.3;
      }
      .twelve {
        margin-bottom: 20px;
      }
    }
  }

</style>
